<template>
  <div>
    <svg
      :width="width1"
      :height="height1"
      viewBox="0 0 45 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.874 0L19.7394 13.5453C19.0281 16.0934 18.2723 18.9545 17.6054 21.592C16.9386 18.9992 16.1828 16.2276 15.427 13.6794L11.2479 0H0V31.8293H7.15776V22.4861C7.15776 17.3899 7.11331 12.6065 6.93547 7.15264C7.55789 9.56666 8.1803 11.623 9.02501 14.35L14.4934 31.8293H20.6286L26.0969 14.35C26.9416 11.623 27.5641 9.52196 28.2309 7.10794C28.0086 12.5618 27.9642 17.3899 27.9642 22.4861V31.8293H35.1219V0H23.874Z"
        fill="white"
      />
      <rect
        x="38.4146"
        y="25.2439"
        width="6.58537"
        height="6.58537"
        fill="white"
      />
    </svg>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: 'Logo',
  props: {
    width1: {
      type: String,
      default: '45'
    },
    height1: {
      type: String,
      default: '32'
    }
  }
}
</script>
